export const DATA_VERSION = '1.0'

export const EVENT_VERSION = '1.1'
